/**
 * Class fragments shared by the kit components. Colors come from tokens only,
 * so every fragment inverts automatically under `.dark`.
 */

/** Brand focus ring for keyboard focus on any interactive control. */
export const FOCUS_RING =
  'outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-surface';

/** Same ring drawn inside the box, for controls that must not grow (tabs, segmented). */
export const FOCUS_RING_INSET = 'outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand';

/** Floating surface for menus, popovers and select lists. */
export const FLOATING_SURFACE =
  'z-popover rounded-card border border-line bg-surface p-1.5 text-ink shadow-e3 outline-none';

/** One row inside a menu / select list. */
export const MENU_ITEM =
  'relative flex h-8 w-full cursor-default select-none items-center gap-2 rounded-control px-2.5 text-sm text-ink outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[highlighted]:bg-surface-hover [&_svg]:size-4 [&_svg]:shrink-0';

/** Height of a select-shaped trigger (`Select`, `Combobox`). */
const SELECT_TRIGGER_HEIGHT = { sm: 'h-8', md: 'h-9' } as const;

/** Closed-state box of a select-shaped control; `Select` and `Combobox` share it so they can't drift. */
export const selectTriggerClass = (size: keyof typeof SELECT_TRIGGER_HEIGHT = 'md') =>
  [
    'inline-flex w-full items-center justify-between gap-2 rounded-control border border-line-strong bg-surface px-3 text-sm text-ink transition-colors',
    'hover:bg-surface-hover disabled:cursor-not-allowed disabled:opacity-50 data-[placeholder]:text-ink-3 aria-invalid:border-danger',
    '[&>span]:truncate',
    SELECT_TRIGGER_HEIGHT[size],
    FOCUS_RING,
  ].join(' ');

/** Chevron at the end of a select-shaped trigger. */
export const SELECT_CHEVRON = 'size-4 shrink-0 text-ink-3';
